var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { VBox, HBox } from "framework/structural_components/hbox_vbox";
import { LoadingSpinner, LoadingError } from "framework/controls/loading";
import { useEventCalendarList, DetailPage, detailPageToString } from "../store";
import { EventState } from "../../entity";
import { Competitions } from "../competitions/view";
import { Competitors } from "../competitors/view";
import { Propositions } from "../propositions/view";
import { CompetitionRegistration } from "../competition_registration/view";
import { Officials } from "../officials/view";
import { cls_item_box, cls_item_date_box, cls_item_date_month, cls_item_date_day, cls_month_title, cls_item_city, cls_item_name, cls_item_detail_link, cls_month_year_caption, cls_item_detail_link_content, cls_add_one_month_box } from "./view.css";
import { cls_backgroundBlack, cls_backgroundGrey80, cls_backgroundWhite, cls_colorBlack, cls_colorCyan70, cls_colorGrey80, cls_colorGrey90, cls_colorMagenta60, cls_colorWhite, cls_cursor_pointer, cls_gap_form, cls_gap_half_rem, cls_gap_line, cls_gap_rem, cls_h4, cls_h6, cls_h9, cls_p5r, cls_text_decoration_line_through, cls_width_100_percent, cls_wrap } from "style/index.css";
import { Link, TextLink } from "framework/link/link";
import { Button } from "framework/controls/button";
import { cls_align_items_center, cls_align_items_stretch } from "framework/structural_components/hbox_vbox.css";
import { useResponsivity } from "framework/responsivity/store";
import { getDayNumberFromUTCDate, getMonthNameShortFromUTCDate, getMonthNameLongByNumber, getDateAndTimeText_DayMonthHourMinute, isValidDate } from "framework/helpers";
import { cls_button_nostyle } from "framework/controls/button.css";
import { useif } from "framework/state/types";
import { UrlPathOfPublicSection } from "common/paths";
import { cls_arrow_right_box } from "framework/link/link.css";
var Item = function (i) {
    var month = getMonthNameShortFromUTCDate(i.date);
    var day = getDayNumberFromUTCDate(i.date);
    var _a = useEventCalendarList(), state = _a[0], actions = _a[1];
    var selectedEventItem = state.selectedEventItem, detailPage = state.detailPage;
    var isSelectedItem = selectedEventItem != null && selectedEventItem.key_ === i.key_;
    var showCompetitions = isSelectedItem && detailPage == DetailPage.Competitions;
    var showCompetitors = isSelectedItem && detailPage == DetailPage.Competitors;
    var showPropositions = isSelectedItem && detailPage == DetailPage.Propositions;
    var showRegistration = isSelectedItem && detailPage == DetailPage.Registration;
    var showOfficials = isSelectedItem && detailPage == DetailPage.Officials;
    var nowIsBeforeRegistrationDeadline = isValidDate(i.registrationDeadline) && new Date() < i.registrationDeadline;
    var showDetail = showCompetitions || showCompetitors || showPropositions || showRegistration || showOfficials;
    var state_resp = useResponsivity()[0];
    var T_HFM = state_resp.thresholdHeaderForMobile;
    var isCanceled = i.state === EventState.Cancelled;
    var isPlanned = i.state === EventState.Approved || i.state === EventState.Waiting;
    var isPlannedAsPrivate = i.state === EventState.Private && i.privateInCalendar === true;
    var isPlannedInAnyWay = isPlanned || isPlannedAsPrivate;
    var baseCalendarUrl = "".concat(UrlPathOfPublicSection, "/kalendar_akci");
    var competitionsUrl = showCompetitions ? baseCalendarUrl : "".concat(UrlPathOfPublicSection, "/kalendar_akci/event/").concat(i.eventId, "/competition/").concat(i.id, "/").concat(detailPageToString(DetailPage.Competitions));
    var propositionsUrl = showPropositions ? baseCalendarUrl : "".concat(UrlPathOfPublicSection, "/kalendar_akci/event/").concat(i.eventId, "/competition/").concat(i.id, "/").concat(detailPageToString(DetailPage.Propositions));
    var officialsUrl = showOfficials ? baseCalendarUrl : "".concat(UrlPathOfPublicSection, "/kalendar_akci/event/").concat(i.eventId, "/competition/").concat(i.id, "/").concat(detailPageToString(DetailPage.Officials));
    var registrationUrl = showRegistration ? baseCalendarUrl : "".concat(UrlPathOfPublicSection, "/kalendar_akci/event/").concat(i.eventId, "/competition/").concat(i.id, "/").concat(detailPageToString(DetailPage.Registration));
    var competitorsUrl = showCompetitors ? baseCalendarUrl : "".concat(UrlPathOfPublicSection, "/kalendar_akci/event/").concat(i.eventId, "/competition/").concat(i.id, "/").concat(detailPageToString(DetailPage.Competitors));
    var linksContent = !isCanceled ? React.createElement(HBox, { className: [cls_gap_rem, cls_wrap, cls_p5r] },
        React.createElement(HBox, { className: [cls_item_detail_link, cls_colorCyan70] },
            React.createElement(Link, { url: competitionsUrl, className: "".concat(cls_button_nostyle, " ").concat(cls_cursor_pointer) },
                React.createElement(HBox, { className: [cls_gap_half_rem, cls_align_items_center] },
                    React.createElement(HBox, null, 'Soutěže'),
                    React.createElement(HBox, { className: cls_arrow_right_box })))),
        React.createElement(HBox, { className: [cls_item_detail_link, cls_colorCyan70] },
            React.createElement(Link, { url: propositionsUrl, className: "".concat(cls_button_nostyle, " ").concat(cls_cursor_pointer) },
                React.createElement(HBox, { className: [cls_gap_half_rem, cls_align_items_center] },
                    React.createElement(HBox, null, 'Propozice'),
                    React.createElement(HBox, { className: cls_arrow_right_box })))),
        React.createElement(HBox, { className: [cls_item_detail_link, cls_colorCyan70] },
            React.createElement(Link, { url: officialsUrl, className: "".concat(cls_button_nostyle, " ").concat(cls_cursor_pointer) },
                React.createElement(HBox, { className: [cls_gap_half_rem, cls_align_items_center] },
                    React.createElement(HBox, null, 'Porota a funkcionáři'),
                    React.createElement(HBox, { className: cls_arrow_right_box })))),
        !isPlannedInAnyWay && nowIsBeforeRegistrationDeadline && React.createElement(HBox, { className: [cls_item_detail_link, cls_colorCyan70] },
            React.createElement(Link, { url: registrationUrl, className: "".concat(cls_button_nostyle, " ").concat(cls_cursor_pointer) },
                React.createElement(HBox, { className: [cls_gap_half_rem, cls_align_items_center] },
                    React.createElement(HBox, null, 'Přihlášení na soutěž'),
                    React.createElement(HBox, { className: cls_arrow_right_box })))),
        !isPlannedInAnyWay && React.createElement(HBox, { className: [cls_item_detail_link, cls_colorCyan70] },
            React.createElement(Link, { url: competitorsUrl, className: "".concat(cls_button_nostyle, " ").concat(cls_cursor_pointer) },
                React.createElement(HBox, { className: [cls_gap_half_rem, cls_align_items_center] },
                    React.createElement(HBox, null, 'Seznam přihlášených'),
                    React.createElement(HBox, { className: cls_arrow_right_box }))))) : null;
    var sectionContent = !isCanceled ? React.createElement(React.Fragment, null, showDetail && React.createElement(VBox, { className: cls_item_detail_link_content },
        showCompetitions && React.createElement(Competitions, { eventCompetitionId: i.id, eventId: i.eventId }),
        showCompetitors && !isPlannedInAnyWay && React.createElement(Competitors, { eventCompetitionId: i.id, eventId: i.eventId, eventCompetition: i }),
        showPropositions && React.createElement(Propositions, null),
        showOfficials && React.createElement(Officials, null),
        showRegistration && nowIsBeforeRegistrationDeadline && React.createElement(CompetitionRegistration, { eventCompetitionId: i.id, eventId: i.eventId }))) : null;
    var ref = React.useRef(null);
    React.useEffect(function () {
        if (state.scrollIntoView && isSelectedItem) {
            if (ref.current) {
                ref.current.scrollIntoView();
            }
            actions.setScrollIntoView(false);
        }
    }, [state.scrollIntoView, isSelectedItem]);
    var hasGreyCalendarDate = isPlannedAsPrivate || isCanceled;
    return React.createElement("div", { ref: ref, className: "".concat(cls_width_100_percent) },
        React.createElement(VBox, { className: [cls_item_box, cls_gap_half_rem] },
            React.createElement(HBox, { className: cls_gap_line },
                React.createElement(VBox, { className: [cls_item_date_box, cls_align_items_stretch] },
                    React.createElement(HBox, { className: [cls_h9, cls_item_date_month, cls_colorWhite, hasGreyCalendarDate ? cls_backgroundGrey80 : cls_backgroundBlack] }, month),
                    React.createElement(HBox, { className: [cls_h4, cls_item_date_day, hasGreyCalendarDate ? cls_colorGrey80 : cls_colorBlack, cls_backgroundWhite] }, day)),
                React.createElement(VBox, { className: cls_gap_half_rem },
                    React.createElement(HBox, { className: [cls_gap_line, cls_item_city, cls_colorGrey90, cls_h9, cls_wrap] },
                        i.competitionsStart && !isCanceled && React.createElement(HBox, null, i.competitionsStart.slice(0, 5)),
                        React.createElement(HBox, null, i.city),
                        i.gps && !isCanceled && React.createElement(HBox, null,
                            React.createElement(TextLink, { url: encodeURI("https://mapy.cz/?q=" + i.gps), targetBlank: true, routesOutOfThisWeb: true }, "GPS")),
                        i.danceFloor && !isCanceled && React.createElement(HBox, null,
                            "PARKET: ",
                            i.danceFloor),
                        i.promoterPropagation && !isCanceled && React.createElement(HBox, null,
                            React.createElement(TextLink, { url: i.promoterPropagation, targetBlank: true, routesOutOfThisWeb: true }, "Link")),
                        !isCanceled && i.registrationDeadline && React.createElement(HBox, { className: isPlannedAsPrivate ? cls_colorGrey90 : cls_colorCyan70 },
                            "P\u0159ihl\u00E1\u0161ky do ",
                            getDateAndTimeText_DayMonthHourMinute(i.registrationDeadline))),
                    React.createElement(HBox, { className: [cls_item_name, cls_h6, useif(isCanceled, cls_text_decoration_line_through), cls_gap_form] },
                        isPlannedInAnyWay && React.createElement(HBox, { className: cls_colorGrey80 }, isPlannedAsPrivate ? "PL\u00C1NOV\u00C1NO" : "NAPL\u00C1NOV\u00C1NO"),
                        React.createElement(HBox, { className: useif(isPlannedAsPrivate, cls_colorGrey90) }, i.name)),
                    isCanceled && React.createElement(HBox, { className: [cls_h6, cls_colorMagenta60] }, "ZRU\u0160ENO"),
                    !T_HFM && linksContent)),
            T_HFM && linksContent,
            React.createElement(HBox, { className: cls_gap_line },
                !T_HFM && React.createElement(VBox, { className: [cls_item_date_box, cls_align_items_stretch] }),
                sectionContent)));
};
var Content = function () {
    var _a = useEventCalendarList(), events = _a[0].events, addOneMonth = _a[1].addOneMonth;
    var monthAndYear = function (my) {
        var m_y = my.split('-');
        var y = m_y[0];
        var m = m_y[1];
        return React.createElement(React.Fragment, null,
            getMonthNameLongByNumber(parseInt(m)),
            "\u00A0",
            y);
    };
    return React.createElement(React.Fragment, null,
        Object.keys(events).map(function (k) { return (React.createElement(VBox, { key: k },
            React.createElement(HBox, { className: cls_month_year_caption },
                React.createElement("h5", { className: cls_month_title }, monthAndYear(k))),
            React.createElement(VBox, null, events[k].map(function (c) { return React.createElement(Item, __assign({ key: c.key_ }, c)); })))); }),
        React.createElement(VBox, { className: [cls_align_items_center, cls_add_one_month_box] },
            React.createElement(Button, { onClick: addOneMonth }, "Načíst další soutěže")));
};
var View = function (props) {
    var _a = useEventCalendarList(), state = _a[0], actions = _a[1];
    var loadingTooLong = state.loadingTooLong, loadFailure = state.loadFailure;
    React.useEffect(function () {
        actions.applyFilter();
    }, [state.filter_state.addOneMonthIndicator]);
    React.useEffect(function () {
        if (props.tabId !== undefined && props.eventId !== undefined && props.eventCompetitionId !== undefined) {
            actions.showDetailPage(props.tabId, props.eventId, props.eventCompetitionId);
        }
        else {
            actions.hideDetailPage();
        }
    }, [props.eventId, props.eventCompetitionId, props.tabId, state.events]);
    React.useEffect(function () {
        if (props.eventId) {
            actions.setScrollIntoView(true);
        }
    }, []);
    // Needed only once when the page is loaded, otherwise the event should already be present in the list.
    // We suppose that after each user modification of the filter the eventCompetition selection is reset.
    React.useEffect(function () {
        if (props.eventId) {
            actions.loadSelectedEventAndAdjustFilterDateRange(props.eventId);
        }
    }, []);
    return React.createElement(VBox, null,
        loadingTooLong && React.createElement(LoadingSpinner, null),
        loadFailure && React.createElement(LoadingError, null),
        React.createElement(Content, null));
};
export { View as List, };
